import React, { useEffect, useState } from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import NotificationManager from "react-notifications/lib/NotificationManager";
import DropDownKendoRct from "../../control-components/drop-down/drop-down";
import { fileDocumentService } from "../../services/fileDocumentTemplateService";
import ApiUrls from "../../helper/api-urls";
import ApiHelper from "../../helper/api-helper";
import Loader from "../../control-components/loader/loader";

const AssignTemplateLabel = ({ onClose, documentTemplateId, regionId, getAllDefaultDocumentTemplates, checkedTemplates }) => {
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState("");
    const [settingError, setSettingError] = useState(false);
    const [templateLabels, setTemplateLabels] = useState([])
    const [label, setlabel] = useState()
    useEffect(() => { getDocumentTemplateLabels() }, []);

    const getDocumentTemplateLabels = (id) => {
        setLoading(true);
        ApiHelper.getRequest(
            ApiUrls.GET_DOCUMENT_TEMPLATE_LABELS + regionId)
            .then((result) => {
                setLoading(false);
                setTemplateLabels(result.resultData);
            })
            .catch((error) => {
                setLoading(false);

                NotificationManager.error(error.message);
            });
    };

    const assignLabel = async () => {
        setLoading(true);
        await fileDocumentService
            .assignTemplateLabel(label, documentTemplateId, regionId, checkedTemplates)
            .then((result) => {
                setLoading(false);
                NotificationManager.success("Template label assigned successfully");
                getAllDefaultDocumentTemplates()
                onClose({ updated: true });
            })
            .catch((error) => {
                setLoading(false);
                NotificationManager.error(error);
            });
    };

    const handleValidation = () => {
        let errors = {};
        let formIsValid = true;
        if (!label) {
            formIsValid = false;
            errors["label"] = "Template label is required";
        }
        setErrors(errors);
        return formIsValid;
    };

    const handleSubmit = () => {
        setSettingError(true);
        if (handleValidation()) {
            assignLabel();
        }
    };

    return (
        <div>
            <Dialog
                onClose={onClose}
                title={"Document Template Label"}
                className="small-dailog" width={"40%"} height={"36%"}
            >
                {loading == true && <Loader />}

                <div className="edit-client-popup">
                    <div className="popup-modal slibling-data">
                        <div className="row">
                            <div>
                                <label className="form-label" style={{ fontSize: "0.875rem" }}>
                                    Template Label
                                </label>
                                <DropDownKendoRct
                                    filterable={true}
                                    onChange={(e) => { setlabel(e.target.value) }}
                                    data={templateLabels}
                                    value={label}
                                    textField="labelName"
                                    name="label"
                                    dataItemKey="id"
                                    suggest={true}
                                    error={!label && errors.label}
                                    validityStyles={settingError}
                                    required={true}

                                />
                            </div>
                        </div>
                    </div>

                </div>
                <div className="border-bottom-line"></div>
                <div className="d-flex my-3">
                    <div className="right-sde">
                        <button className="green-btn btn-primary mx-3 btn-space" onClick={handleSubmit}>
                            Submit
                        </button>
                    </div>
                    <div className="right-sde-grey">
                        <button
                            className="btn grey-secondary text-white btn-space"
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </Dialog>
        </div>
    );
};
export default AssignTemplateLabel;
